// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* our variables */\n.v-tabs--vertical > .v-tabs-bar .v-tab[data-v-5ebb141b] {\n  justify-content: end;\n}\n.analysis-menu .v-list-item[data-v-5ebb141b] {\n  min-height: 28px;\n}", ""]);
// Exports
module.exports = exports;
